/**
 * Typed binding for GET /admin/audit (PR #5f).
 *
 * `list(query)` requires `admin.audit.view`.
 */

import {
  AuditListResponseSchema,
  type AuditListQuery,
  type AuditListResponse,
} from '../schemas/audit.js';
import type { RequestOptions, Transport } from './transport.js';

export interface AuditClient {
  list(query?: Partial<AuditListQuery>, options?: RequestOptions): Promise<AuditListResponse>;
}

const buildListPath = (query: Partial<AuditListQuery> | undefined): string => {
  if (!query) return '/admin/audit';
  const params = new URLSearchParams();
  if (query.category !== undefined) params.set('category', query.category);
  if (query.action !== undefined) params.set('action', query.action);
  if (query.actorUserId !== undefined) params.set('actorUserId', query.actorUserId);
  if (query.entityId !== undefined) params.set('entityId', query.entityId);
  if (query.fromDate !== undefined) params.set('fromDate', query.fromDate);
  if (query.toDate !== undefined) params.set('toDate', query.toDate);
  if (query.page !== undefined) params.set('page', String(query.page));
  if (query.pageSize !== undefined) params.set('pageSize', String(query.pageSize));
  const qs = params.toString();
  return qs.length === 0 ? '/admin/audit' : `/admin/audit?${qs}`;
};

export const createAuditClient = (transport: Transport): AuditClient => ({
  list: (query, options) => transport.get(buildListPath(query), AuditListResponseSchema, options),
});
